import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import aliasing from "./components/aliasing";
import pureSignal from "./components/pure-signal";
import dft from "./components/dft";

const principle: Slide = {
  description:
    "Please find here three illustrations of the characteristic phenomena of digital processing of discrete signals",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Aliasing in frequency domain" },
            { name: "Sampling of a pure signal" },
            { name: "Discrete Fourier Transform" },
          ],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], [], [], []],
      components: [aliasing, pureSignal, dft],
    },
  },
};

export default principle;
